import request from "@/utils/request";
import qs from "qs";
// 获取渠道个人中心数据
export function getXcChannelUsetCenterMsg() {
  return request({
    url: "api/xcChannel/center",
    method: "Get",
  });
}
// 修改密码
export function updatePassBySmsCode(msg) {
  return request({
    url: "api/users/updatePassBySmsCode",
    data: msg,
    method: "post",
  });
}
// 获取下级渠道
export function getSubChannelList(params) {
  return request({
    url: "api/getSubChannelList?" + qs.stringify(params, { indices: false }),
    method: "Get",
  });
}

// 获取注册海报
export function getSignPoster() {
  return request({
    url: "api/getSignPoster",
    method: "Get",
  });
}



// WEBPACK FOOTER //
// ./src/api/userCenter.js